module.exports = __webpack_public_path__ + "img/code.cca9b5d4.jpg";